"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailModel = exports.RegistrationModel = exports.LoginModel = void 0;
var class_validator_1 = require("class-validator");
var LoginModel = /** @class */ (function () {
    function LoginModel() {
    }
    __decorate([
        class_validator_1.IsNotEmpty(),
        class_validator_1.IsEmail(),
        __metadata("design:type", String)
    ], LoginModel.prototype, "email", void 0);
    __decorate([
        class_validator_1.IsNotEmpty(),
        __metadata("design:type", String)
    ], LoginModel.prototype, "password", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", Array)
    ], LoginModel.prototype, "validRoles", void 0);
    return LoginModel;
}());
exports.LoginModel = LoginModel;
var RegistrationModel = /** @class */ (function () {
    function RegistrationModel() {
    }
    __decorate([
        class_validator_1.IsNotEmpty(),
        class_validator_1.IsEmail(),
        __metadata("design:type", String)
    ], RegistrationModel.prototype, "email", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], RegistrationModel.prototype, "password", void 0);
    __decorate([
        class_validator_1.IsNotEmpty(),
        __metadata("design:type", String)
    ], RegistrationModel.prototype, "role", void 0);
    return RegistrationModel;
}());
exports.RegistrationModel = RegistrationModel;
var EmailModel = /** @class */ (function () {
    function EmailModel() {
    }
    __decorate([
        class_validator_1.IsNotEmpty(),
        class_validator_1.IsEmail(),
        __metadata("design:type", String)
    ], EmailModel.prototype, "email", void 0);
    return EmailModel;
}());
exports.EmailModel = EmailModel;
//# sourceMappingURL=AuthenticateModel.js.map